import React from "react";
import AdminLayout from "../components/layout/AdminLayout";
import AdminAnalyticsCards from "../components/admin/AdminAnalyticsCards";
import DashboardQuickActions from "../components/admin/DashboardQuickActions";
import RecentDocumentsPanel from "../components/admin/RecentDocumentsPanel";
import RecentActivityPanel from "../components/admin/RecentActivityPanel";
import SectionHeader from "../components/common/SectionHeader";

export default function DashboardPage() {
  return (
    <AdminLayout
      title="Dashboard"
      subtitle="Track operational health and jump into the right workflow quickly."
    >
      <div className="dashboard-hero">
        <div className="dashboard-hero-card">
          <div>
            <h2 className="dashboard-hero-title">
              Welcome to WOW-Sign Workspace
            </h2>
            <p className="dashboard-hero-subtitle">
              Use this dashboard to monitor workflow health, jump into
              documents, and keep signing operations moving smoothly.
            </p>
          </div>
        </div>
      </div>

      <div className="section-space">
        <SectionHeader
          title="Quick Actions"
          subtitle="Jump directly to the most common operational tasks."
          chips={["Fast Access", "Daily Operations"]}
        />
        <DashboardQuickActions />
      </div>

      <div className="section-space">
        <SectionHeader
          title="Operational Snapshot"
          subtitle="High-level document and signer activity across the workspace."
          chips={["Live Overview", "Business Health"]}
        />
        <AdminAnalyticsCards />
      </div>

      <div className="dashboard-lower-grid">
        <div className="section-space">
          <SectionHeader
            title="Recent Documents"
            subtitle="Quickly continue working on recently created or updated documents."
            chips={["Recent"]}
          />
          <RecentDocumentsPanel />
        </div>

        <div className="section-space">
          <SectionHeader
            title="Workspace Guidance"
            subtitle="Recommended workflow for delivery-ready document processing."
            chips={["Tips"]}
          />
          <RecentActivityPanel />
        </div>
      </div>
    </AdminLayout>
  );
}
